import { Stack, Text } from "@fluentui/react";

const Finished = () => {
    return <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', marginTop: '5%', marginBottom:'100px' }}>
        <Stack tokens={{ childrenGap: '8' }} horizontalAlign={"center"} >
            <Text variant="xxLargePlus" styles={{ root: { fontWeight: '180' } }}>Process is complete.</Text>
            <span>
                You can now close this window.
            </span>
        </Stack>
    </div>;
}

export default Finished;
